import * as React from 'react'
  /* @jsx mdx */
import { mdx } from '@mdx-js/react';
/* @jsxRuntime classic */

/* @jsx mdx */

export const _frontmatter = {
  "title": "Appcelerator Titanium might've made it to my toolbox",
  "description": "",
  "published": "2012-01-23T00:00:00.000Z",
  "redirect_from": ["/blog/appcelerator-titanium-mightve-made-it-to-my-toolbox/swizec/3506"],
  "categories": "Android, Appcelerator, Appcelerator Titanium, Integrated development environment, IOS, JavaScript, Programming, Titanium, Uncategorized, User interface",
  "hero": "../../../defaultHero.jpg"
};
const layoutProps = {
  _frontmatter
};
const MDXLayout = "wrapper";
export default function MDXContent({
  components,
  ...props
}) {
  return <MDXLayout {...layoutProps} {...props} components={components} mdxType="MDXLayout">
    <p>{`Last time I played around with `}<a parentName="p" {...{
        "href": "http://www.appcelerator.com/",
        "title": "Appcelerator Titanium"
      }}>{`Appcelerator Titanium`}</a>{` I didn't get a chance to `}<a parentName="p" {...{
        "href": "http://swizec.com/blog/i-learned-two-things-today-11-8/swizec/2150"
      }}>{`really put it through its paces`}</a>{`. Mostly because I wasn't getting anywhere ... I remember spending hours, even days, just figuring out how to get a `}<a parentName="p" {...{
        "href": "http://en.wikipedia.org/wiki/Hello_world_program",
        "title": "Hello world program"
      }}>{`Hello World`}</a>{` to run in a simulator.`}</p>
    <p><img parentName="p" {...{
        "src": "https://swizec.com/blog/wp-content/uploads/2012/01/5638371774_324ec18c31_m4.jpg",
        "alt": "MoBods Scoop! Development ;-)",
        "title": "MoBods Scoop! Development ;-)"
      }}></img></p>
    <p>{`Yesterday was my lucky day! Not only did I get something to run, I actually made something useful. Or rather, I was given a working app and told to add some features and generally make it better a tiny little bit.`}</p>
    <p>{`Took me way too long - expected when dealing with technology you know `}<em parentName="p">{`nothing`}</em>{` about - but at 6am today I had `}<a parentName="p" {...{
        "href": "http://www.pickup.io/"
      }}>{`Pickup`}</a>{` connecting to the server on the user's own private channel and talking nicely to the `}<a parentName="p" {...{
        "href": "http://googlevoiceblog.blogspot.com/2010/01/new-google-voice-extension-for-chrome.html",
        "title": "Chrome extension"
      }}>{`Chrome extension`}</a>{`.`}</p>
    <p>{`By the way this isn't my project, I just helped out, but from what I saw last night, you `}<em parentName="p">{`want`}</em>{` to sign up for the beta. Promise!`}</p>
    <h2 {...{
      "id": "titanium-good"
    }}>{`Titanium good`}</h2>
    <ol>
      <li parentName="ol">{`It's `}<a parentName="li" {...{
          "href": "http://en.wikipedia.org/wiki/JavaScript",
          "title": "JavaScript"
        }}>{`Javascript`}</a>{`, if you haven't noticed I `}<em parentName="li">{`love`}</em>{` javascript`}</li>
      <li parentName="ol">{`The same app works both on android and `}<a parentName="li" {...{
          "href": "http://www.apple.com/ios",
          "title": "IOS"
        }}>{`iOS`}</a></li>
      <li parentName="ol">{`Titanium API's are generally simpler than what I've seen of native iOS`}</li>
      <li parentName="ol">{`Properly using the `}<a parentName="li" {...{
          "href": "http://en.wikipedia.org/wiki/User_interface",
          "title": "User interface"
        }}>{`user interface`}</a>{` API's gives you a native look&feel`}</li>
    </ol>
    <h2 {...{
      "id": "titanium-bad"
    }}>{`Titanium bad`}</h2>
    <ol>
      <li parentName="ol">{`The `}<a parentName="li" {...{
          "href": "http://en.wikipedia.org/wiki/Integrated_development_environment",
          "title": "Integrated development environment"
        }}>{`IDE`}</a>{`; I don't like being forced to use an IDE and I very much hate being forced to use a `}<em parentName="li">{`crappy`}</em>{` IDE.`}</li>
      <li parentName="ol">{`Everything looks like it would be pretty much impossible to develop with my usual `}<a parentName="li" {...{
          "href": "http://en.wikipedia.org/wiki/Text_editor",
          "title": "Text editor"
        }}>{`text editor`}</a>{` method`}</li>
      <li parentName="ol">{`Code once, run everywhere is good in principle, but it usually ends up lacking the polish of a real native app, especially since android and iOS have slightly different `}<a parentName="li" {...{
          "href": "http://en.wikipedia.org/wiki/User_interface",
          "title": "User interface"
        }}>{`UI`}</a>{` guidelines and traditions`}</li>
    </ol>
    <h2 {...{
      "id": "conclusion"
    }}>{`Conclusion`}</h2>
    <p>{`All in all, there's a lot of potential in this Titanium stuff despite the shortcomings. I might just start adding a mobile part to my future projects ... there's certainly some that could use it.`}</p>
    <h6 {...{
      "id": "related-articles"
    }}>{`Related articles`}</h6>
    <ul>
      <li parentName="ul"><a parentName="li" {...{
          "href": "http://www.mobile-ent.biz/news/read/appcelerator-bags-15m-series-c-round/016007"
        }}>{`Appcelerator bags `}{`\\`}{`\\`}{`\\`}{`\\$15m series C round`}</a>{` (mobile-ent.biz)`}</li>
      <li parentName="ul"><a parentName="li" {...{
          "href": "http://blog.elemdage.com/technology/one-mans-html5-developer-workflow"
        }}>{`One Man's HTML5 Developer Workflow`}</a>{` (elemdage.com)`}</li>
      <li parentName="ul"><a parentName="li" {...{
          "href": "http://www.fiercedeveloper.com/story/appcelerator-acquires-html5-development-platform-particle-code/2011-10-24"
        }}>{`Appcelerator acquires HTML5 development platform Particle Code`}</a>{` (fiercedeveloper.com)`}</li>
      <li parentName="ul"><a parentName="li" {...{
          "href": "http://venturebeat.com/2011/11/01/appcelerator-raises-15m/"
        }}>{`Appcelerator raises `}{`\\`}{`\\`}{`\\`}{`\\$15M, now largest third-party app publisher on iOS, Android`}</a>{` (venturebeat.com)`}</li>
    </ul>
    <p><a parentName="p" {...{
        "href": "http://www.zemanta.com/",
        "title": "Enhanced by Zemanta"
      }}><img parentName="a" {...{
          "src": "https://img.zemanta.com/zemified_e.png?x-id=41f5b6aa-6958-4ac1-95b3-78f47d955e65",
          "alt": "Enhanced by Zemanta"
        }}></img></a></p>

    </MDXLayout>;
}
;
MDXContent.isMDXComponent = true;
      